import { Space } from "antd"
import React from "react"

import { cn } from "../../utils/cn.ts"

interface IconWithTextProps extends React.ComponentProps<typeof Space> {
  icon: () => React.ReactNode
  text: string
}

export const IconWithText = ({
  icon: Icon,
  text,
  className,
  ...props
}: IconWithTextProps) => (
  <Space {...props} className={cn("text-with-icon", className)}>
    {Icon()}
    <span>{text}</span>
  </Space>
)

export default IconWithText
